import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {SettingsRoutingModule} from './settings-routing.module';
import {SharedModule} from '../../../../shared/shared.module';
import {HcaGeneralComponent} from './hca-general/hca-general.component';
import {HcaSettingsComponent} from './hca-settings/hca-settings.component';
import {HcaUserManagementDetailsComponent} from './hca-user-management/hca-user-management-details/hca-user-management-details.component';
import {HcaUserManagementListComponent} from './hca-user-management/hca-user-management-list/hca-user-management-list.component';
import {HcaUserManagementMainComponent} from './hca-user-management/hca-user-management-main/hca-user-management-main.component';
import {HcaUserManagementService} from '../../../../shared/_services/hca-user-management.service';
import {HcaBrandComponent} from './hca-brand/hca-brand.component';
import {HcaLoyaltyProgramsComponent} from './hca-loyalty-programs/hca-loyalty-programs.component';

import {FormsModule} from '@angular/forms';
import {HcaUserManagementAddComponent} from './hca-user-management/hca-user-management-add/hca-user-management-add.component';
import {HcaBrandService} from '../../../../shared/_services/hca-brand.service';
import {HcaLoyaltyWebsiteMainComponent} from './hca-loyalty-website/hca-loyalty-website-main/hca-loyalty-website-main.component';
import {HcaLoyaltyWebsiteHeaderFooterComponent} from './hca-loyalty-website/hca-loyalty-website-header-footer/hca-loyalty-website-header-footer.component';
import {HcaLoyaltyWebsiteFontColorComponent} from './hca-loyalty-website/hca-loyalty-website-font-color/hca-loyalty-website-font-color.component';
import {HcaLoyaltyWebsiteLandingPageComponent} from './hca-loyalty-website/hca-loyalty-website-landing-page/hca-loyalty-website-landing-page.component';
import {LandingPageHeroBannerComponent} from './hca-loyalty-website/landing-page-hero-banner/landing-page-hero-banner.component';
import {HcaLoyaltyWebsitePreviewComponent} from './hca-loyalty-website/hca-loyalty-website-preview/hca-loyalty-website-preview.component';
import {LandingPageBookingWidgetComponent} from './hca-loyalty-website/landing-page-booking-widget/landing-page-booking-widget.component';
import {LandingPageCatalogBannerComponent} from './hca-loyalty-website/landing-page-catalog-banner/landing-page-catalog-banner.component';
import {LandingPageNextStepComponent} from './hca-loyalty-website/landing-page-next-step/landing-page-next-step.component';
import {LoyaltyWebsiteOtherPagesComponent} from './hca-loyalty-website/loyalty-website-other-pages/loyalty-website-other-pages.component';
import {HcaHistoryChangesListComponent} from './hca-history-changes/hca-history-changes-list/hca-history-changes-list.component';
import {HcaHistoryChangesService} from '../../../../shared/_services/hca-history-changes.service';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    SettingsRoutingModule,
  ],
  declarations: [
    HcaGeneralComponent,
    HcaSettingsComponent,
    HcaUserManagementMainComponent,
    HcaUserManagementListComponent,
    HcaUserManagementDetailsComponent,
    HcaUserManagementAddComponent,
    HcaHistoryChangesListComponent,
    HcaBrandComponent,
    HcaLoyaltyProgramsComponent,
    HcaLoyaltyWebsiteMainComponent,
    HcaLoyaltyWebsiteHeaderFooterComponent,
    HcaLoyaltyWebsiteFontColorComponent,
    HcaLoyaltyWebsiteLandingPageComponent,
    LoyaltyWebsiteOtherPagesComponent,
    LandingPageHeroBannerComponent,
    HcaLoyaltyWebsitePreviewComponent,
    LandingPageBookingWidgetComponent,
    LandingPageCatalogBannerComponent,
    LandingPageNextStepComponent
  ],
  providers: [
    HcaUserManagementService,
    HcaBrandService,
    HcaHistoryChangesService]
})
export class SettingsModule {
}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/settings/settings.module.ts